export default __webpack_public_path__ + "images/e2add90e54008945aa8db707c4a905bb-oval_icon.svg";